import { AttachmentIntendedUse } from '@lib/enums/attachments';

/**
 * Attachment interface with metadata for intendedUse filtering
 */
export interface AttachmentWithIntendedUse {
  id: string;
  urls?: {
    small?: string | null;
    medium?: string | null;
    original?: string | null;
  } | null;
  metadata?: {
    intendedUse?: string | null;
  } | null;
}

/**
 * Finds attachment by intendedUse metadata from an array of attachments.
 *
 * @param attachments - Array of attachments to search through
 * @param intendedUse - The intendedUse value to match
 * @returns The matching attachment or undefined if not found
 */
export default function findAttachmentByIntendedUse(
  attachments: AttachmentWithIntendedUse[] | null | undefined,
  intendedUse: AttachmentIntendedUse,
): AttachmentWithIntendedUse | undefined {
  if (!attachments || attachments.length === 0) return undefined;
  return attachments.find((att) => att.metadata?.intendedUse === intendedUse);
}
